export const downloadFileFromServer = (blob, v) => {
  if (navigator.appVersion.toString().indexOf(".NET") > 0) {
    window.navigator.msSaveBlob(blob, v.name);
  } else {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = v.name;
    a.click();
  }
};

export const downloadFileLocal = (file) => {
  if (navigator.appVersion.toString().indexOf(".NET") > 0) {
    window.navigator.msSaveBlob(file, file.name);
  } else {
    var link = document.createElement("a");
    link.download = file.name;
    link.href = URL.createObjectURL(file);
    link.click();
  }
};

export const manipulateString=(str)=>{
  
  if(str.toString().includes("_id"))
    var str1=str.substring(0, str.length-3);
  else
    var str1=str.toString()
  str1=str1.replace("_", " ").replace("_", " ").replace("_", " ");
  return str1.charAt(0).toUpperCase() + str1.slice(1);
}
